import script from "./VehiclesRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehiclesRow.vue?vue&type=script&setup=true&lang=ts"

import "./VehiclesRow.vue?vue&type=style&index=0&id=28fd435e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28fd435e"]])

export default __exports__